import axios from 'axios'
import { FRANCHISE_URL } from './api'
import { authorizationHelper } from '../common/helpers'

export function getFranchiseBilling(billing_type, month, year) {
    const params = {
        billing_type,
        month,
        year
    }
    const url = `${FRANCHISE_URL}/billing`
    return axios.get(url, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function generateBilling(data) {
    const url = `${FRANCHISE_URL}/billing`
    return axios.post(url, data, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}



// WEBPACK FOOTER //
// ./src/service/franchise.js